<template>
  <span>{{ isEstimate ? '~' : '' }}{{ formattedDollars }}</span>
</template>

<script>
export default {
  name: 'AmountCents',
  props: {
    cents: Number,
    isEstimate: Boolean
  },
  computed: {
    formattedDollars () {
      let dollarStr = (this.cents / 100.0).toLocaleString(undefined, { style: 'currency', currency: 'USD' })
      if (this.meta.showNoCents) {
        return dollarStr
      }
      const noCentsIdx = dollarStr.indexOf('.00')
      return noCentsIdx < 0 ? dollarStr : dollarStr.substring(0, noCentsIdx)
    }
  }
}
</script>

<style scoped>

</style>
